import { BrowserAgent } from "@newrelic/browser-agent/loaders/browser-agent";
// helpers
import { buildNewRelicOptions } from "./buildNewRelicOptions";
import { parseNewRelicBrowserConfig } from "./parseNewRelicConfig";
import { NewRelicBrowserAppConfigInput } from "./types";

let isInitialized = false;

export const initNewRelicFromAppConfig = (config: NewRelicBrowserAppConfigInput): void => {
  if (typeof window === "undefined" || isInitialized) {
    return;
  }

  const parsedConfig = parseNewRelicBrowserConfig(config);

  if (!parsedConfig) {
    return;
  }

  try {
    new BrowserAgent(buildNewRelicOptions(parsedConfig));
    isInitialized = true;
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      // eslint-disable-next-line no-console
      console.error("Failed to initialize New Relic Browser Agent:", error);
    }
  }
};
